import * as React from 'react';
import * as classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import AnimateHeight from '../../../../Utils/AnimateHeight';
import { SVG } from '../../../../Utils/SVG';
import { EVENT_HANDLED_NAV } from '../../../../../constants';
import { NavigationItem, NavigationRoot } from '../../../../../models';
import { MobileNavigationSubmenu } from './MobileNavigationSubmenu';
import './style.css';
const arrowUpIcon = require('../../../../../icons/arrow-up.svg');

export interface MobileNavigationItemProps {
  item: NavigationItem;
  expanded: boolean;
  onToggleMobileItem(item: NavigationRoot): void;
}

export interface MobileNavigationItemState {
  /* empty */
}

export class MobileNavigationItem extends React.Component<
  MobileNavigationItemProps,
  MobileNavigationItemState
> {
  render() {
    const { item } = this.props;
    const classes = classNames({
      'mobile-navigation-item': true
    });

    const rootItem = item as NavigationRoot;
    if (rootItem.children && rootItem.children.length) {
      return this.getLinkWithSubmenu(item, classes);
    }

    return this.getLinkWithoutSubmenu(item, classes);
  }

  private getLinkWithSubmenu = (item: NavigationItem, baseClasses: string) => {
    const { expanded } = this.props;
    const rootItem = item as NavigationRoot;

    const classes = classNames({
      expanded
    });

    return (
      <li className={baseClasses + ' ' + classes} key={item.name}>
        {/* HACK: Links don't work inside of buttons in IE11 it seems, so use a div + role */}
        <div
          className="mobile-navigation-toggle-button"
          role="button"
          onClick={event => this.onToggleItem(event, rootItem)}
        >
          {this.getLink(item)}
          <SVG className="mobile-navigation-toggle-icon" src={arrowUpIcon} />
        </div>
        <AnimateHeight height={expanded ? 'auto' : 0}>
          <MobileNavigationSubmenu item={rootItem} />
        </AnimateHeight>
      </li>
    );
  };

  private getLinkWithoutSubmenu = (item: NavigationItem, classes: string) => {
    return (
      <li className={classes} key={item.name}>
        <div className="mobile-navigation-link-wrapper">
          {this.getLink(item)}
        </div>
      </li>
    );
  };

  private getLink = (item: NavigationItem): JSX.Element => {
    return (
      <NavLink
        className={classNames({
          'edge-of-play-link': true,
          'mobile-navigation-link': true,
          'premium-mobile-navigation-link': item.url === '/premier'
        })}
        to={item.url || `#`}
        onClick={item.onClick}
      >
        {item.name}
      </NavLink>
    );
  };

  private onToggleItem = (
    event: React.MouseEvent<HTMLDivElement>,
    item: NavigationRoot
  ) => {
    const eventTarget = event.target as HTMLElement;
    if (eventTarget.tagName.toLowerCase() === 'a') {
      // Don't handle the link in the button being clicked
      return;
    }

    const { onToggleMobileItem } = this.props;

    // Flag the toggle event as handled to prevent nav closing
    event.persist();
    event[EVENT_HANDLED_NAV] = true;

    onToggleMobileItem(item);
  };
}

export default MobileNavigationItem;



// WEBPACK FOOTER //
// ./src/app/components/App/Navigation/MobileNavigation/MobileNavigationItem/index.tsx